/*
 * Bradoria hero carousel — pairs with sections/brd-hero.liquid.
 * Vanilla JS, no deps. Auto-advances every `data-brd-hero-interval` ms
 * (default 6000), pauses on hover, supports prev/next/dot clicks +
 * keyboard arrow keys when the hero has focus.
 */
(() => {
  const heroes = document.querySelectorAll('[data-brd-hero]');
  if (!heroes.length) return;

  heroes.forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-brd-hero-slide]'));
    const slots  = Array.from(root.querySelectorAll('[data-brd-hero-slot]'));
    const dots   = Array.from(root.querySelectorAll('[data-brd-hero-dot]'));
    const prev   = root.querySelector('[data-brd-hero-prev]');
    const next   = root.querySelector('[data-brd-hero-next]');
    const counter = root.querySelector('[data-brd-hero-counter-current]');
    const interval = parseInt(root.dataset.brdHeroInterval || '6000', 10);
    if (slides.length < 2) return;

    let idx = 0;
    let timer = null;
    let paused = false;

    const setActive = (n) => {
      idx = (n + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === idx;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.toggleAttribute('inert', !active);
        slide.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach((control) => {
          if (active) control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', '-1');
        });
      });
      slots.forEach((s, i) => {
        s.classList.toggle('is-active', i === idx);
        s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === idx;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(idx + 1).padStart(2, '0');
    };

    const start = () => {
      stop();
      if (paused) return;
      timer = setInterval(() => setActive(idx + 1), interval);
    };
    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin',     () => { paused = true; stop(); });
    root.addEventListener('focusout',    () => { paused = false; start(); });

    prev && prev.addEventListener('click', () => { setActive(idx - 1); start(); });
    next && next.addEventListener('click', () => { setActive(idx + 1); start(); });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const n = parseInt(dot.dataset.brdHeroDot, 10);
        setActive(n);
        start();
      });
    });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { setActive(idx - 1); start(); }
      if (e.key === 'ArrowRight') { setActive(idx + 1); start(); }
    });

    setActive(0);

    // Respect prefers-reduced-motion: no auto-advance, manual controls only.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    start();
  });
})();
